// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--2XPv6","img":"hero-module--img--miuKI"};